<template>
    <div >
       
    </div>
</template>
<script>
    export default {
        props: ['title'],
        data() {
            return {
                Displaytitle:""
              }
        }
    }
</script>